import React, {Component} from "react";
import {PropertyContainerComponent} from "./PropertyContainerComponent";
import {DragDropContext, DropResult} from "react-beautiful-dnd";
import {isEqual} from "underscore";
import {
    TabOrderWidget,
} from "ui/experience/widgets/toolbox/TabOrder/TabOrderDndTypes";
import {DraggableColumnComponent} from "@zmags/zmags-ui-library";
import KeyCode from "shared/services/KeyCode";

interface WidgetLayerOrderContainerProps {
    widgets: TabOrderWidget[];
    widgetSelected: boolean;
    selectedId?: string;
    onDragEnd: (oldIndex: number, newIndex: number) => void;
    onDragStart: (widgetId: string) => void;
    onDragCancel: () => void;
    onActionClick: (widgetId: string, actionType: string) => void;
    onLayerChanging: (widgetId: string) => void;
    onDragRelease: (widgetId: string) => void;
}

interface WidgetLayerOrderContainerState {
    shouldForceUpdate: boolean;
    touchedId: string;
}

class WidgetLayerOrderContainer extends Component<WidgetLayerOrderContainerProps, WidgetLayerOrderContainerState> {
    
    state = {
        shouldForceUpdate: false,
        touchedId: null
    }
    
    onDragEnd = (result: DropResult) => {
        if (!result.destination) {
            this.props.onDragCancel();
        } else {
            this.props.onDragEnd(
                result.source.index,
                result.destination.index
            );
        }
        this.setState({touchedId: result.draggableId});
    }

    onDragCancel = () => {
        this.props.onDragCancel();
    }

    onDragStart = (widgetId: string) => {
        if (widgetId !== this.props.selectedId) {
            this.props.onDragStart(widgetId);
        }
    }

    haveWidgetsChanged = (widgets: TabOrderWidget[], previousWidgets: TabOrderWidget[]) => {
        return widgets.length !== previousWidgets.length ||
        widgets.find((widget, index) => {
            // we're assuming the order remains the same. Maybe we should always force an update.
            const previousWidget = previousWidgets[index];
            return !isEqual(widget, previousWidget);
        });
    }

    onKeyDown = ({keyCode}) => {
        const {selectedId, widgets, onLayerChanging} = this.props;

        if (selectedId) {
            const selectedIdIndex = widgets.findIndex(widget => widget.id === selectedId);

            if (selectedIdIndex !== -1) {
                let nextIndex: number = selectedIdIndex;

                if(keyCode === KeyCode.DOWN) {
                    nextIndex = nextIndex + 1 > widgets.length - 1 ? 0 : nextIndex + 1;
                }

                if(keyCode === KeyCode.UP) {
                    nextIndex = nextIndex - 1 < 0 ? widgets.length - 1 : nextIndex - 1;
                }

                if (selectedIdIndex !== nextIndex) {
                    onLayerChanging(widgets[nextIndex].id)
                }
            }
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.onKeyDown);
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.onKeyDown, false);
    }

    componentDidUpdate =
        (prevProps: Readonly<WidgetLayerOrderContainerProps>): void => {
            const shouldForceUpdate = this.haveWidgetsChanged(this.props.widgets, prevProps.widgets);
            const isUpdatedWidget = prevProps.selectedId && prevProps.selectedId !== this.props.selectedId;

            if((!!shouldForceUpdate && !this.state.shouldForceUpdate) || isUpdatedWidget || this.state.touchedId) {
                this.setState({shouldForceUpdate: true, touchedId: null});
            } else if(this.state.shouldForceUpdate) {
                this.setState({shouldForceUpdate: false, touchedId: null});
            }
        }

    render() {
        const {widgets, selectedId} = this.props;
        const {shouldForceUpdate} = this.state;

        return (
            <PropertyContainerComponent
                widgetSelected={false}
                label={"Widget Layer Order"}
                name={"experience-settings"}
                animateExpandOnMount={false}
            >
                {!shouldForceUpdate && widgets.length > 0 && <DragDropContext onDragEnd={this.onDragEnd}>
                    <DraggableColumnComponent
                        items={widgets}
                        columnId={"WIDGET_LAYER_ORDER"}
                        label="Widget Layer Order"
                        onDragStart={this.onDragStart}
                        onDragCancel={this.onDragCancel}
                        onDragRelease={this.props.onDragRelease}
                        selectedId={selectedId}
                        touchedId={this.state.touchedId}
                        onActionClick={this.props.onActionClick}
                        draggableWrapperClassName="layer-drag-wrapper"
                    />
                </DragDropContext>}
            </PropertyContainerComponent>
        );
    }
}

export {WidgetLayerOrderContainer as default}



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/toolbox/WidgetLayerOrderContainer.tsx